import { AlertItem } from './hooks/useAlerts';
import { AlertTitle, AlertMessage, AlertLayout } from './components/Alert';
import ParsedContent, { ParsedContentFormat } from './components/ParsedContent';

import { CartQuery_magento2_cart_items } from './context/__generated__/CartQuery';

/*
  Magento advices use the __typename field on returned items to determine their specific implementation of CartItemInterface (distinguish btn software / hardware)
*/
export const isSoftwareCartItem = <T extends CartQuery_magento2_cart_items>(
  item?: T | null
): boolean => item?.__typename === 'Magento2_VirtualCartItem';

export const isHardwareCartItem = <T extends CartQuery_magento2_cart_items>(
  item?: T | null
): boolean => item?.__typename === 'Magento2_SimpleCartItem';

// Temporary until we find a better solution from cms side
export function stripHTML(htmlText?: string | null | undefined): string {
  if (!htmlText) return '';

  try {
    return (
      new DOMParser().parseFromString(htmlText, 'text/html')?.firstChild
        ?.textContent ?? ''
    );
  } catch (e) {
    return htmlText;
  }
}

export const cmsBlockToAlertItem = ({
  type,
  format,
  actions,
  cmsBlock: { title, content },
}: CmsBlockToAlertItemArgs): AlertItem => ({
  type,
  actions,
  persist: true,
  layout: content && title ? AlertLayout.Column : AlertLayout.Row,
  content: (
    <>
      {title ? (
        <AlertTitle>
          <ParsedContent format={format}>{title}</ParsedContent>
        </AlertTitle>
      ) : null}
      {content ? (
        <AlertMessage>
          <ParsedContent format={format}>{content}</ParsedContent>
        </AlertMessage>
      ) : null}
    </>
  ),
});

export const round = (value: number): number => +value.toFixed(2);

export const convertToEuro = (
  amount?: number | null,
  currency?: string | null
): number => {
  const EXCHANGE_RATE = {
    AUD: 0.619437,
    CAD: 0.670287,
    CHF: 0.919201,
    CNY: 0.131703,
    GBP: 1.17189,
    JPY: 0.0077546,
    USD: 0.850455,
  };

  if (!amount || !currency) return 0;

  return EXCHANGE_RATE[currency]
    ? round(amount * EXCHANGE_RATE[currency])
    : amount;
};

interface CmsBlockToAlertItemArgs extends Pick<AlertItem, 'type' | 'actions'> {
  cmsBlock: { title?: string | null; content?: string | null };
  format?: ParsedContentFormat;
}
